import { SocietyCorporateId } from 'types/Society';

export const loginsByCorporateId = {
  [SocietyCorporateId.DEFAULT]: {
    societyName: 'Sttok',
    pageStyle: 'login-page-default',
    logo: '/images/logo-dark.png',
    accessTitle: 'IdentifyYourself',
    accessText: 'AccessSttok',
    warning: null,
    button: {
      icon: 'ni-signin',
      text: 'Login',
    },
  },
  [SocietyCorporateId.AXA]: {
    societyName: 'Agrupació AMCI',
    pageStyle: 'login-page-axa',
    logo: 'https://resources.sttok.com/images/logo-axa-header.png',
    accessTitle: 'IdentifyYourself',
    accessText: 'AccessAxa',
    warning: {
      text: 'LoginWarningAxa',
      email: 'accionista@gacm.es',
    },
    button: {
      icon: 'ni-signin',
      text: 'Login',
    },
  },
};
